module.exports = __webpack_public_path__ + "static/media/21ECLAC39.9c9f4dae.jpg";